import React from 'react';
import './QuickFacts.css';

import FlipCards from '../../../components/FlipCards/FlipCards';

const quickFacts = ( props ) => {
	if( props.cards ) {
		props.cards.forEach( card => {
			card.side2class = 'bg-color-2';
		});
	}
	
	return (
		<section id="QuickFacts">
			<h2>Quick Tidbits</h2>
			<p className="titleNote">
				Tips to keep safe and productive
			</p>
			<FlipCards className="bg-gradient vertical" cards={ props.cards } />
		</section>
	);
};

export default quickFacts;



// WEBPACK FOOTER //
// ./src/pages/IT/QuickFacts/QuickFacts.js